import { render } from "./BaseInputText.vue?vue&type=template&id=822700d0&scoped=true"
import script from "./BaseInputText.vue?vue&type=script&lang=ts"
export * from "./BaseInputText.vue?vue&type=script&lang=ts"

import "./BaseInputText.vue?vue&type=style&index=0&id=822700d0&lang=css"
import "./BaseInputText.vue?vue&type=style&index=1&id=822700d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-822700d0"

export default script